import React from 'react';

const getCookie = (cookieName) => {
    const cookie = {};
    document.cookie.split(';').forEach((el) => {
        const [key, value] = el.split('=');
        cookie[key.trim()] = value;
    });
    return cookie[cookieName];
};

const LoginAuto = () => {
    React.useEffect(() => {
        localStorage.setItem('authToken', getCookie('token'));
        const prefix = `${process.env.PUBLIC_URL}/`.replace('//', '/');
        window.location.href = `${prefix}home`;
        document.cookie = '';
    }, []);
    return null;
};

export default LoginAuto;
